export default __webpack_public_path__ + "static/media/compiegne12.39efceba.jpg";